import { render, staticRenderFns } from "./Curso.vue?vue&type=template&id=68ab99a0&scoped=true&"
import script from "./Curso.vue?vue&type=script&lang=js&"
export * from "./Curso.vue?vue&type=script&lang=js&"
import style0 from "./Curso.vue?vue&type=style&index=0&id=68ab99a0&lang=scss&scoped=true&"
import style1 from "./Curso.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./Curso.vue?vue&type=style&index=2&id=68ab99a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ab99a0",
  null
  
)

export default component.exports